"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'voices.david.description': '深沉、舒缓的音调，充满友善和真诚。',
};
